import { connect } from 'react-redux';
import { requestCommission, editCommission } from '../modules/commission';

import Commissions from '../components/Commissions';

const mapDispatchToProps = {
  requestCommission,
  editCommission,
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.commission.isFetching,
  needFetch: state.commission.needFetch,
  hasError: state.commission.hasError,
  commissions: state.commission.commissions,
  id: ownProps.params.id,
});

export default connect(mapStateToProps, mapDispatchToProps)(Commissions);



// WEBPACK FOOTER //
// src/routes/commissions/containers/CommissionsContainer.js